import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Box, Tooltip, Button, Link } from '@codex/basics';
import { Popup } from '@codex/organisms';
import Icon from '@dc/ui-library/src/molecules/Icon/Icon';

const StyledBox = styled(Box)`
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  max-width: 400px;
  margin-bottom: 0;
  border-bottom-left-radius: inherit;
  border-bottom-right-radius: inherit;
`;

const StyledTooltip = styled(Tooltip)`
  margin-bottom: 10px;
  display: flex;
  align-items:center;
`;

const StyledIcon = styled(Icon)`
  color: #EE9022;
  margin-right: 10px;
  width: 60px;
  max-width: 28px;
`;

const StyledButton = styled(Button)`
  max-width: none;
`;

const StyledLink = styled(Link)`
  margin-top: 10px;
`;

class PopupMessage extends React.Component {
  constructor(props) {
    super(props);
    this.handleOnClose = this.handleOnClose.bind(this);
    this.handleOnTryAgain = this.handleOnTryAgain.bind(this);
  }

  handleOnClose() {
    window.location.href = this.props.navigateButton.url;
    this.props.onClose();
  }

  handleOnTryAgain() {
    this.props.onTryAgain();
  }

  render() {
    const {
      message,
      title,
      retryButton: {
        title: buttonTitle
      },
      navigateButton: {
        title: linkTitle,
        url
      }
    } = this.props;
    return (
      <Popup
        title={title}
        onClose={this.handleOnClose}
        optionalClasses={'eligibilityPopupMessage'}
      >
        <>
          <StyledBox>
            <StyledTooltip type={'warning'} textAlign={'left'}>
              <>
                <StyledIcon size={'large'} icon={'Alert'} />
                <div>{message}</div>
              </>
            </StyledTooltip>
            <StyledButton onClick={this.handleOnTryAgain}>{buttonTitle}</StyledButton>
            <StyledLink href={url}>{linkTitle}</StyledLink>
          </StyledBox>
        </>
      </Popup>
    );
  }
}

PopupMessage.propTypes = {
  message: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  retryButton: PropTypes.shape({
    title: PropTypes.string.isRequired
  }).isRequired,
  navigateButton: PropTypes.shape({
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
  }).isRequired,
  onClose: PropTypes.func,
  onTryAgain: PropTypes.func.isRequired
};

PopupMessage.defaultProps = {
  onClose: () => {}
};

PopupMessage.displayName = 'PopupMessage';

export default PopupMessage;
